import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';
import { normalizeCustomerEquipmentTypes } from './normalize';

export const fetchCustomerEquipmentTypes = createProvider(api.fetchCustomerEquipmentTypes)
  .andThen((res) => normalizeCustomerEquipmentTypes(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch list aborted');
    } else {
      console.error('Fetch list was failed:', error);
    }
    throw error;
  });
